$(document).ready(function(){
	$('.home-marquee').cycle({
		pager: '.cycle-nav'
	});



	$('.gallery-image').click(function(e) {
        if (!$(this).attr('rel')) {
            return;
        }
        
        $('.gallery-image').removeClass('active');
        $('.modal').removeClass('active').hide();
        $('#' + $(this).attr('rel')).addClass('active').fadeIn();
        $(this).addClass('active');
    });

    $('.modal .btn-close').click(function() {
		$(this).parent().parent().fadeOut(400);
		$('body').removeClass('no-overflow');
	});
	
	$('.social-shares').click(function(e) {
		$(this).siblings('.social-wrap').fadeIn();
	});
});